export interface LegalArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const legalData: LegalArticle[] = [
  {
    title: "Mentions Légales",
    content: [
      {
        mainText:
          "Le présent site est édité et géré par Virtuosa pour le compte de HOLDING ALEXANDRA :",
      },
      {
        bulletPoints: [
          "Dénomination sociale : HOLDING ALEXANDRA",
          "Forme juridique : SARL unipersonnelle",
          "Capital social : 729 000,00€",
          "Siège social : 28 RUE DE SAINT-CLOUD, 92410 VILLE-D'AVRAY, France",
          "Immatriculée au RCS de Nanterre : SIREN 802338103, TVA intracommunautaire FR61802338103",
          "Contact : alexandra.grey.coiffure@gmail.com",
          "Directrice de publication : Mme EECKHOUT Alexandra",
        ],
      },
      {
        additionalText: [
          "Le site alexandra-grey.fr permet l'achat de cartes cadeaux et formations en ligne. Ces services sont gérés exclusivement par HOLDING ALEXANDRA.",
          "Tous les paiements sont sécurisés via Stripe. Virtuosa décline toute responsabilité en cas de problème lié aux transactions financières, qui doivent être adressées à HOLDING ALEXANDRA : alexandra.grey.coiffure@gmail.com.",
          "Pour toute problématique technique ou erreur constatée sur le site, contactez Virtuosa : agence@virtuosa.fr",
        ],
      },
    ],
  },
  {
    title: "Protection des Données (RGPD)",
    content: [
      {
        mainText:
          "Vos données personnelles sont collectées et traitées par HOLDING ALEXANDRA pour :",
      },
      {
        bulletPoints: [
          "Gérer vos demandes et prises de contact",
          "Assurer le suivi des commandes ou achats de cartes cadeaux et formations",
        ],
      },
      {
        additionalText: [
          "Conformément au RGPD et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez des droits suivants :",
          "Droit d'accès, de rectification et de suppression de vos données",
          "Droit d'opposition ou de limitation au traitement",
          "Droit à la portabilité de vos données",
        ],
      },
      {
        contactInfo:
          "Pour exercer vos droits : alexandra.grey.coiffure@gmail.com",
      },
      {
        mainText:
          "Cookies : Le site peut utiliser des cookies pour améliorer la navigation. Vous pouvez les désactiver via les réglages de votre navigateur.",
      },
    ],
  },
  {
    title: "Propriété Intellectuelle",
    content: [
      {
        mainText:
          "La structure du site, les textes, les designs, les codes et tout autre contenu sont la propriété exclusive de Virtuosa, sauf cession de droits explicitement prévue dans le devis.",
      },
      {
        bulletPoints: [
          "Toute reproduction (totale ou partielle) est interdite sans autorisation écrite de Virtuosa.",
          "Les marques et logos figurant sur ce site sont protégés et leur réutilisation non autorisée est passible de poursuites.",
        ],
      },
      {
        additionalText: [
          "La cession des droits de propriété intellectuelle, si prévue, ne devient effective qu'après le règlement intégral des prestations.",
          "Toute modification des services ou fichiers livrés sans autorisation de Virtuosa annulera toute garantie de bon fonctionnement et pourra entraîner des frais supplémentaires en cas de réintervention demandée.",
          "En cas de résiliation avant paiement intégral, les droits de propriété intellectuelle et les fichiers associés restent la propriété exclusive de Virtuosa.",
        ],
      },
    ],
  },
  {
    title: "Conditions Générales d'Utilisation (CGU)",
    content: [
      {
        mainText: "En naviguant sur alexandra-grey.fr, vous acceptez de :",
      },
      {
        bulletPoints: [
          "Respecter les lois en vigueur et les droits de propriété intellectuelle",
          "N'utiliser le site que pour des finalités légitimes (consultation, informations, achat de cartes cadeaux ou formations)",
          "Ne pas porter atteinte au bon fonctionnement du site (virus, piratage, etc.)",
        ],
      },
      {
        additionalText: [
          "Responsabilités : Virtuosa met tout en œuvre pour assurer l'exactitude des informations techniques. Toutefois, en cas d'erreur ou de dysfonctionnement, Virtuosa ne saurait être tenu responsable des conséquences liées à l'utilisation du contenu du site.",
        ],
      },
    ],
  },
  {
    title: "Conditions Générales de Vente (CGV)",
    content: [
      {
        mainText: "Prestations et Tarifs",
      },
      {
        bulletPoints: [
          "Les services de coiffure, formations et cartes cadeaux sont décrits sur le site ; les prix indiqués sont en euros, TTC.",
          "HOLDING ALEXANDRA peut modifier ses tarifs à tout moment, sans préavis.",
        ],
      },
      {
        mainText: "Commandes et Paiement",
      },
      {
        bulletPoints: [
          "Toute commande implique l'acceptation des présentes CGV.",
          "Le paiement s'effectue en ligne via Stripe.",
        ],
      },
      {
        mainText: "Droit de Rétractation",
      },
      {
        bulletPoints: [
          "Vous disposez de 14 jours pour vous rétracter si la prestation ou la carte cadeau n'a pas été utilisée.",
          "Les demandes sont à adresser par mail : alexandra.grey.coiffure@gmail.com.",
        ],
      },
      {
        mainText: "Litiges",
      },
      {
        bulletPoints: [
          "Tout litige est régi par le droit français et relève de la compétence exclusive des tribunaux de Nanterre.",
        ],
      },
    ],
  },
  {
    title: "Acceptation",
    content: [
      {
        mainText:
          "En utilisant le site alexandra-grey.fr, vous déclarez avoir lu et accepté l'ensemble de ces mentions légales, CGU et CGV.",
      },
    ],
  },
];
